import { analyticsAPI } from './api';

class AnalyticsService {
  async getMetrics(params = {}) {
    const response = await analyticsAPI.getMetrics(params);
    return response.data;
  }

  async getComplianceReport(params = {}) {
    const response = await analyticsAPI.getComplianceReport(params);
    return response.data;
  }

  async getExpiredEquipment(params = {}) {
    const response = await analyticsAPI.getExpiredEquipment(params);
    return response.data;
  }
}

const analyticsService = new AnalyticsService();
export default analyticsService;